const selectSettings = (state) => state.settings;

export default selectSettings;
